<template>
  <div class="ai-jd-panel">
    <Loader v-if="profileLoading" />
    <template v-else>
      <AiJdDetail
        v-if="jdView === 'detail' && selectedJd"
        :jd="selectedJd"
        :applicantId="applicantId"
        @back="backToList"
      />

      <div v-else class="ai-jd-panel-list">
        <div class="mb-4">
          <h5 class="font-weight-bold mb-3">登録者がスカウト希望した求人</h5>
          <div v-if="scoutedItems.length > 0" class="scouted-jd-list">
            <div
              v-for="jd in scoutedItems"
              :key="jd._id"
              class="scouted-jd-row"
            >
              <span class="scouted-jd-badge">{{ scoutedBadgeText(jd) }}</span>
              <span class="scouted-jd-title">{{ jd.job_title }}</span>
            </div>
          </div>
          <div v-else>
            <p>スカウト希望した求人はありません。</p>
          </div>
        </div>

        <div class="mb-4">
          <h5 class="font-weight-bold mb-3">AIマッチしたJD</h5>
          <div v-if="matchedJds.length > 0">
            <AiJdMatchCard
              v-for="(jd, index) in matchedJds"
              :key="jd._id"
              :jd="jd"
              :rank="index + 1"
              @open="openDetail"
            />
          </div>
          <div v-else>
            <p>AIマッチしたJDはありません。</p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Loader from '@/components/utils/Loader.vue';
import AiJdMatchCard from './AiJdMatchCard.vue';
import AiJdDetail from './AiJdDetail.vue';

export default {
  name: 'AiJdPanel',
  components: { Loader, AiJdMatchCard, AiJdDetail },
  props: {
    applicantId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      profileLoading: 'getAiProfileLoading',
      jobSeeker: 'getAiJobSeeker',
      matchedJds: 'getAiMatchedJds',
      jdView: 'getAiJdView',
      selectedJd: 'getAiSelectedJd',
    }),
    scoutedItems() {
      const scoutedJobs = (this.jobSeeker && this.jobSeeker.scouted_jobs) || [];
      return scoutedJobs.map((scoutedJob) => ({
        _id: scoutedJob.jobDetails._id,
        job_title: scoutedJob.jobDetails.job_title,
        job: scoutedJob.job,
        status: scoutedJob.status,
      }));
    },
  },
  methods: {
    ...mapMutations({
      setAiJdView: 'setAiJdView',
      setAiSelectedJd: 'setAiSelectedJd',
    }),
    ...mapActions({
      loadProfileWithAiJds: 'loadProfileWithAiJds',
    }),
    openDetail(jd) {
      this.setAiSelectedJd(jd);
      this.setAiJdView('detail');
    },
    backToList() {
      this.setAiSelectedJd(null);
      this.setAiJdView('list');
    },
    scoutedBadgeText(jd) {
      return jd.status === 'expired' ? 'スカウト希望期間終了' : 'スカウト希望中';
    },
  },
  created() {
    this.loadProfileWithAiJds(this.applicantId);
  },
};
</script>

<style scoped>
.ai-jd-panel {
  height: 100%;
  position: relative;
  background-color: #ebeff1;
  overflow: hidden;
}

.ai-jd-panel-list {
  height: 100%;
  overflow-y: auto;
  padding: 40px 20px 20px 20px;
}

.scouted-jd-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background-color: #fff;
  margin-bottom: 10px;
}

.scouted-jd-row:last-child {
  margin-bottom: 0;
}

.scouted-jd-badge {
  flex-shrink: 0;
  height: 24px;
  border-radius: 12px;
  background-color: #ececec;
  color: #666;
  font-size: 11px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  text-align: center;
  white-space: nowrap;
}

.scouted-jd-title {
  flex: 1 1 0;
  min-width: 0;
  font-size: 13px;
  color: #333;
  font-weight: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.scouted-jd-list {
  max-height: 170px;
  overflow-y: auto;
  padding-right: 8px;
  scrollbar-width: thin;
  scrollbar-color: #c4c4c4 transparent;
}

.scouted-jd-list::-webkit-scrollbar {
  width: 6px;
}

.scouted-jd-list::-webkit-scrollbar-track {
  background: transparent;
}

.scouted-jd-list::-webkit-scrollbar-thumb {
  background-color: #c4c4c4;
  border-radius: 3px;
}

.scouted-jd-list::-webkit-scrollbar-thumb:hover {
  background-color: #a3a3a3;
}
</style>
